import { BaseComponent, IStateBase } from 'components/BaseComponent';
import React from 'react';
import Dialog from '@material-ui/core/Dialog/Dialog';
import YoutubeEmbed from 'components/YoutubeEmbed/index';
import { cartService } from 'services/CartService';
import DialogTitle from '@material-ui/core/DialogTitle/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import DialogActions from '@material-ui/core/DialogActions/DialogActions';
import { showAlert } from 'shared/services/dialog';
import Close from '@material-ui/icons/Close';
import { enPaymentType } from 'enums/enPaymentType';
import { getCdnImage } from 'functions';
import { IProductData } from 'interfaces/IProductData';
import Fab from '@material-ui/core/Fab';
import { exitPopUpService } from 'services/ExitPopUpService';
import { WithStyles } from 'shared/decorators/withStyles';

interface IState extends IStateBase {
  cart: IProductData;
  open: boolean;
  timerMinutes: string;
  timerSeconds: string;
}

@WithStyles(() => ({
  component: {
    '& div[class^="MuiPaper-root-"]': {
      overflow: 'hidden',
      maxWidth: '600px',
      maxHeight: '500px'
    },
    '& iframe': {
      border: 0
    },
    '& .close-icon': {
      position: 'absolute',
      right: '10px',
      top: '15px'
    },
    '& .chk-btn-action': {
      width: '100%',
      height: 'auto',
      margin: 0,
      border: 0,
      '& .btn-receive-discount': {
        backgroundColor: '#000',
        color: '#FFFFFF',
        padding: '25px 30px',
        fontWeight: 500,
        fontSize: '1.2rem',
        margin: 0,
        display: 'inline-block',
        border: 0,
        width: '100%',
        height: 'auto',
        overflow: 'hidden',
        position: 'relative',
        transition: 'all .3s ease-in-out',
        cursor: 'pointer'
      }
    },
    '& .chk-dialog-text': {
      padding: 0,
      overflow: 'hidden',
      minWidth: '600px',
      height: '450px',
      '& .chk-youtube': {
        height: '100%'
      },
      '& .chk-img-modal': {
        width: '100%',
        height: '100%'
      }
    },
    '& .chk-dialog-header': {
      color: '#FFFFFF',
      padding: '24px 24px 5px 24px',
      width: '100%',
      height: '100%',
      backgroundColor: 'rgb(51, 51, 51)',
      textAlign: 'center',
      '& span': {
        fontSize: '0.9rem',
        color: 'white'
      },
      '& h2': {
        display: 'flex',
        flexSirection: 'column',
        alignItems: 'center'
      },
      '& .chk-timer': {
        width: '3rem',
        color: '#FFFFFF',
        fontSize: '1.5rem',
        borderRadius: '5px',
        padding: '0.2rem'
      }
    }
  }
}))
export default class ExitPopUp extends BaseComponent<IState, {}> {
  constructor(props: any) {
    super(props);
    this.state = {
      open: false,
      timerMinutes: '14',
      timerSeconds: '57',
      cart: null
    };
  }

  componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());

    exitPopUpService
      .verifyTimer()
      .bindComponent(this)
      .subscribe(registredValue => {
        this.handleClickOpen();
        this.setTimer(registredValue);
      });

    exitPopUpService
      .mouseEvent()
      .bindComponent(this)
      .subscribe(registredValue => {
        this.handleClickOpen();
        this.setTimer(registredValue);
      });

    exitPopUpService
      .listenPostMessage()
      .map(data => {
        if (!data.selectedOption) {
          this.setState({ open: false });
          return null;
        }

        if (data.selectedOption.id == 'exitPopUp') {
          this.setState({ open: true });
        } else {
          this.setState({ open: false });
        }
      })
      .bindComponent(this)
      .subscribe(() => {});
  }

  setTimer = (registredValue: any) => {
    const clock = setInterval(() => {
      let actualValue: any = new Date().getTime();
      let finalValueMinutes = (registredValue - actualValue) / 1000 / 60;
      let finalValueSeconds = ((registredValue - actualValue) / 1000 / 60 - Math.trunc(finalValueMinutes)) * 60;

      this.setState({
        timerMinutes: ('0' + Math.floor(finalValueMinutes)).slice(-2),
        timerSeconds: ('0' + finalValueSeconds.toFixed(0)).slice(-2)
      });

      if (parseInt(this.state.timerMinutes) <= 0 && parseInt(this.state.timerSeconds) <= 0) {
        this.setState({ open: false });
        clearInterval(clock);
      }
    }, 1000);
  };

  handleClickOpen = () => {
    this.setState({ open: true });

    window.requestAnimationFrame(() => {
      const audio: HTMLAudioElement = document.querySelector('#audioModal');

      if (!audio) {
        return;
      }

      try {
        audio.play();
      } catch (err) {
        console.log('browser bloqueou a execução do audio');
      }
    });
  };

  handleClose = () => {
    this.setCoupon();
    this.setState({ open: false });
  };

  setCoupon = () => {
    const coupon = (this.state.cart.config.exitModal && this.state.cart.config.exitModal.coupon) || null;

    if (!coupon) {
      return;
    }

    cartService
      .setCoupon(this.state.cart.config.exitModal.coupon, 2)
      .catch(() => {
        return showAlert('Ocorreu um erro ao aplicar o seu cupom, tente novamente').map(() => false);
      })
      .bindComponent(this)
      .subscribe();
  };

  render() {
    if (!this.state.cart) {
      return null;
    }

    const { cart } = this.state;
    const mediaImage = cart.config.exitModal.media.image;
    const image = mediaImage && mediaImage.includes('data:') ? mediaImage : getCdnImage(mediaImage);

    return (
      <div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={this.props.classes.component}
        >
          <Fab id="chk-exitpopup-close-button" size="small" className="close-icon" color="default" aria-label="Fechar" onClick={this.handleClose}>
            <Close />
          </Fab>
          <DialogTitle className="chk-dialog-header theme-exit-pop-up-header">
            <span className="theme-exit-pop-up-title">{cart.config.exitModal.timer.theme.title}</span>
            {cart.config.exitModal.timer.enabled ? (
              <div className="theme-exit-pop-up-timer">
                {this.state.timerMinutes}:{this.state.timerSeconds}
              </div>
            ) : null}
          </DialogTitle>
          <DialogContent className="chk-dialog-text">
            {cart.config.exitModal.media.video ? (
              <YoutubeEmbed url={cart.config.exitModal.media.video} />
            ) : (
              cart.config.exitModal.media.image &&
              image && (
                <img
                  className="chk-img-modal"
                  src={
                    cart.config.exitModal.media.image.includes('data:')
                      ? cart.config.exitModal.media.image
                      : getCdnImage(cart.config.exitModal.media.image)
                  }
                />
              )
            )}
            {cart.config.exitModal.media.audio ? (
              <audio id="audioModal">
                <source type="audio/mpeg" src={cart.config.exitModal.media.audio} />
              </audio>
            ) : null}
          </DialogContent>
          <DialogActions className="chk-btn-action">
            {cart.config.exitModal.button.enabled && cart.config.paymentType !== enPaymentType.FREE ? (
              <button id="chk-exitpopup-button" className={'btn-receive-discount theme-exit-pop-up-button'} onClick={this.handleClose}>
                {cart.config.exitModal.button.theme.text}
              </button>
            ) : (
              ''
            )}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
